import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
    // loadChildren: () =>
    //   import('./views/tabs/tabs.module').then((m) => m.TabsPageModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./views/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'dummy',
    loadChildren: () => import('./views/dummy/dummy.module').then(m => m.DummyPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'register/:id',
    loadChildren: () => import('./views/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./views/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'changepassword',
    loadChildren: () => import('./views/changepassword/changepassword.module').then(m => m.ChangepasswordPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./views/forget-password/forget-password.module').then(m => m.ForgetPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./views/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./views/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'signin-privacy-policy',
    loadChildren: () =>
      import('./views/signin-privacy-policy/signin-privacy-policy.module').then(m => m.SigninPrivacyPolicyPageModule)
  },
  {
    path: 'guest/:id',
    loadChildren: () => import('./views/guest/guest.module').then(m => m.GuestPageModule)
  },
  {
    path: 'qr-subcontractor',
    loadChildren: () =>
      import('./views/qr-subcontractor/qr-subcontractor.module').then(m => m.QrSubcontractorPageModule)
  },
  {
    path: 'qr-project-swms',
    loadChildren: () => import('./views/qr-project-swms/qr-project-swms.module').then(m => m.QrProjectSwmsPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    useHash: true
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
